import { ErrorMessage } from './error-message';


export const ERROR_MESSAGES: ErrorMessage[]  = [
  {
    error: 'required',
    format: _ => 'Campo obrigatório'
  },
  {
    error: 'pattern',
    format: _ => 'Campo inválido'
  },
  {
    error: 'minlength',
    format: error => `must be at least ${error.requiredLength} characters`
  },
  {
    error: 'maxlength',
    format: error => `must be no longer than ${error.requiredLength} characters`
  },
  {
    error: 'requiredTrue',
    format: _ => `Campo obrigatório`
  },
  {
    error: 'email',
    format: _ => `Favor informar um e-mail válido`
  },
  {
    error: 'max',
    format: error => `must be no greater than ${error.max}`
  },
  {
    error: 'min',
    format: error => `must be no less than ${error.min}`
  },
  {
    error: 'mismatchedPasswords',
    format: error => 'As senhas devem ser iguais'
  },
  {
    error: 'cpf',
    format: _ => 'CPF informado inválido'
  }
];
